import React from 'react';
import Box from '@mui/material/Box';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

function Save({ widgetStyle, widgetProps }) {

    const responsive = {
        0: { items: 1 },
        801: { items: 2 },
        1024: { items: 3 },
        1280: { items: 4 },
    };
    const items = widgetProps?.images && widgetProps?.images?.map((data, index) => (
        <Box key={index} data-value={index + 1} sx={[{ overflow: 'hidden' }, widgetStyle.item ?? {}]}>
            <Box component={'img'} src={data} sx={{ width: 1, height: 1, objectFit: 'cover' }} />
        </Box>
    ));
    const carousel = React.useRef(null);
    return (
        <Box sx={[widgetStyle ?? {}, { minHeight: '100px' }]}>
            <AliceCarousel
                disableDotsControls
                disableButtonsControls
                touchTracking={true}
                autoHeight
                autoPlay={true}
                autoPlayInterval={3000}
                infinite={true}
                ref={carousel}
                items={items}
                responsive={responsive}
                controlsStrategy="default"
            />
        </Box>
    )
}

export default React.memo(Save);